import GetCodeForm from './GetCodeForm'

export default GetCodeForm
